/* unplugin-vue-components disabled */import script from "./xPaperLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./xPaperLayout.vue?vue&type=script&setup=true&lang=js"

import "./xPaperLayout.vue?vue&type=style&index=0&id=738e066a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738e066a"]])

export default __exports__